import { createComponent } from '@helpers/admin';
import CallRatesCostsSectionComponent from '@template/blocks/CallRatesCostsSection/component';

export const CallRates = createComponent({
  label: 'Call Rates',
  component: CallRatesCostsSectionComponent,
  fields: {
    title: {
      label: 'Title',
      type: 'text',
    },
    context: {
      label: 'Type',
      type: 'select',
      options: [
        {
          label: 'National',
          value: 'national',
        },
        {
          label: 'International',
          value: 'international',
        },
      ],
    },
    inverted: {
      label: 'Grey Background',
      type: 'boolean',
    },
  },
});
